import { render } from "./App.vue?vue&type=template&id=e0853bdc"
const script = {}

import exportComponent from "/Users/mac/Documents/Personal_Projects/zamin-travel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__